import { render, staticRenderFns } from "./CharterUploadsForm.vue?vue&type=template&id=b5680bb2&"
import script from "./CharterUploadsForm.vue?vue&type=script&lang=js&"
export * from "./CharterUploadsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports